import axios from "axios";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";

const API_NAME = "eventDocument";

export const eventDocumentService = {
    getAll,
    eventTemplateManage,
    eventManage,
    disable,
};

function getAll(eventId?: number, eventDocumentTempalateId?: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?eventId=${eventId}&eventDocumentTempalateId=${eventDocumentTempalateId}`, requestOptions).then(handleResponse);
}

function eventTemplateManage(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.post(`${API_URL}/${API_NAME}/eventTemplateManage`, model, config);
}

function eventManage(model: any) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.post(`${API_URL}/${API_NAME}/eventManage`, model, config);
}

function disable(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
}
